// === Libs ===
import React, { FC } from "react";
import { PollCardTypes } from "@/components/poll-card/poll-card.types";
import { PollCard } from "@/components/poll-card/poll-card";
import classes from "./poll-list.module.scss";

// === Style ===

interface PollListInterface {
  count: string | number;
  total: string | number;
  elementList: Array<PollCardTypes.PollCardModel>;
  orgId?: number;
}

const PollList: FC<PollListInterface> = ({
  count = 0,
  total = 0,
  elementList = [],
  orgId,
}) => {
  return elementList.length ? (
    <div className={classes.list}>
      {elementList?.map((item) => {
        return <PollCard {...item} orgId={orgId} />;
      })}
    </div>
  ) : (
    <p>По вашему запросу ничего не найдено</p> // TODO: красивое сообщение "не найдено"
  );
};
export { PollList };
